import { Card, Stack } from '@mui/material';

import { Strings } from '@app/constants';
import { UpcomingHolidaysCard, ProjectContribution } from '@app/components/card';
import { IHoliday } from '@app/modules/holidays';
import { ITaskOverview } from '@app/modules/dashboard';

interface props {
  holidays: IHoliday;
  project: ITaskOverview;
}
const EmployeeProgress = ({ holidays, project }: props) => {
  return (
    <Stack flexDirection={{ sm: 'column', md: 'row' }}>
      <Card
        sx={{
          height: '450px',
          margin: '0 0 0 2%',
          borderRadius: '5px',
          width: { xs: '96%', md: '50%' },
        }}
      >
        <UpcomingHolidaysCard
          title={Strings.employeeDashborad.upcomingHolidays}
          holidays={holidays}
        />
      </Card>
      <Card
        sx={{
          borderRadius: '5px',
          width: { xs: '96%', md: '50%' },
          margin: '0% 2% 2.5% 2%',
          padding: 2,
          height: '450px',
          mt: { xs: 2, md: 0 },
        }}
      >
        <ProjectContribution
          title={Strings.employeeDashborad.projectsContribution}
          projectData={project}
        />
      </Card>
    </Stack>
  );
};

export { EmployeeProgress };
